import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_WHD_FORM_UPLOADS_REQUEST = 'GET_WHD_FORM_UPLOADS_REQUEST';
export const GET_WHD_FORM_UPLOADS_SUCCESS = 'GET_WHD_FORM_UPLOADS_SUCCESS';
export const GET_WHD_FORM_UPLOADS_FAILURE = 'GET_WHD_FORM_UPLOADS_FAILURE';

function requestGetWhdFormUploads() {
  return {
    type: GET_WHD_FORM_UPLOADS_REQUEST,
    isGettingForms: true
  };
}

function receiveGetWhdFormUploads(forms, formsCount, gridTotalLimit) {
  return {
    type: GET_WHD_FORM_UPLOADS_SUCCESS,
    isGettingForms: false,
    forms,
    formsCount,
    gridTotalLimit
  };
}

function rejectGetWhdFormUploads() {
  return {
    type: GET_WHD_FORM_UPLOADS_FAILURE,
    isGettingForms: false
  };
}

export function getWhdFormUploads(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, accountId) {
  return (dispatch) => {
    dispatch(requestGetWhdFormUploads());
    const promise = () => ApiService
      .getWhdFormUploads(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, accountId)
      .then((response) => {
        dispatch(receiveGetWhdFormUploads(response.data.items, response.data.totalCount, response.data.totalLimit));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetWhdFormUploads, true));
        }
      });
    return promise();
  };
}

export function getWhdFormUploadsByObject(requestObject) {
  return getWhdFormUploads(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.accountId,
  );
}
